import { useSelector } from "react-redux";
import { Role } from '../../constants/roles';

export function useHasOneOfRoles(roles: Role[]) {
    const userRoles = useSelector((state) => state.user.profile.roles);

    return roles.some(role => userRoles.includes(role));
}
